import React, { ChangeEvent, FC, InputHTMLAttributes } from 'react';
import TextField from '@mui/material/TextField';
import alert_triangle from '../../assets/images/icons/alert-triangle.svg';
import { InputAdornment, useTheme } from '@mui/material';

const InputStyle = {
	border: '1px solid #969696',
	borderRadius: '5px',
	background: 'background: #FFFFFF',
	width: '100%',
	'& .MuiInputLabel-root': {
		color: '#707070'
	},
	'& .Mui-focused': {
		color: '#707070'
	},
	'& .MuiInputBase-root': {
		'& .MuiInputBase-input:focus': {
			border: 'none'
		}
	},
	marginTop: '20px'
};

const InputErrorStyle = {
	border: '1px solid #b3261e !important'
};

interface StyledInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
	id: string;
	value: string;
	placeholder?: string;
	disabled?: boolean;
	error?: boolean;
	errorId?: string;
	onChange: (value: string) => void;
}

const StyledInput: FC<StyledInputProps> = ({
	id,
	value,
	onChange,
	placeholder,
	disabled = false,
	error = false,
	errorId,
	...props
}: StyledInputProps) => {
	const theme = useTheme();

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value as string;
		onChange(value);
	};

	const errorStyle = error ? InputErrorStyle : {};
	const InputSX = {
		...InputStyle,
		'&:focus-within': {
			border: `1px solid ${theme.palette.primary.main} !important`
		},
		...errorStyle
	};

	return (
		<TextField
			id={id}
			value={value}
			label={placeholder}
			variant="filled"
			inputMode="text"
			disabled={disabled}
			onChange={handleChange}
			className="controlled-input txt-field"
			error={error}
			sx={InputSX}
			InputProps={{
				startAdornment: error && <AlertInputAdornment />,
				inputProps: {
					...props,
					'aria-invalid': error || undefined,
					'aria-describedby': error && errorId ? errorId : undefined,
					style: { color: `${error ? '#b3261e' : 'black'}` }
				}
			}}
			InputLabelProps={{
				style: {
					color: `${error ? '#b3261e' : '#707070'}`,
					fontSize: '18px'
				}
			}}
		/>
	);
};

export default React.memo(StyledInput);

const AlertInputAdornment: FC = () => {
	return (
		<InputAdornment
			position="start"
			className="input-adornment"
			sx={{
				backgroundColor: '#ffffff',
				borderRadius: '5px'
			}}
		>
			<img src={alert_triangle} alt="" aria-hidden="true" className="input-adornment-image" />
		</InputAdornment>
	);
};
